import { IUseGraphqlWatchQueryOptions } from '@proscom/prostore-apollo-react';
import { InternshipsPageInput, InternshipsPageType } from '../../types';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { ONE_PAGE_ITEMS } from '../../../constants';
import { QUERY_GET_INTERNSHIPS } from '../../queries/internships';

const queryOptions: IUseGraphqlWatchQueryOptions<
  { input: InternshipsPageInput },
  InternshipsPageType
> = {
  query: QUERY_GET_INTERNSHIPS,
  mapData: (result) => result.internshipsPage
};

export function useInternships({ filter, pagination }: InternshipsPageInput) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: {
      input: {
        filter,
        pagination: {
          onePage: ONE_PAGE_ITEMS,
          ...pagination
        }
      }
    }
  });
}
